import React from 'react';
interface CTAButtonProps {
  text: string;
}
export const CTAButton = ({
  text
}: CTAButtonProps) => {
  return <a href="https://www.clickrtrckr.com/5CXCQDK/42BXCKW/" target="_blank" rel="noopener noreferrer" className="inline-block bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-8 rounded-lg transition-colors duration-200 text-lg shadow-md hover:shadow-lg" data-id="element-80">
      {text}
    </a>;
};